import React, { useEffect, useState } from 'react';
import './EarnedCredits.css';

export default function EarnedCredits({ credits = 150 }) {
  const [displayCredits, setDisplayCredits] = useState(0);

  useEffect(() => {
    let start = 0;
    const end = parseInt(credits, 10);
    if (end === 0) return;

    // Total duration of the counting animation in milliseconds
    const duration = 1200; 
    // Calculate speed dynamically so larger number increments stay within the duration limit
    const incrementTime = Math.max(Math.floor(duration / end), 15);
    
    const timer = setInterval(() => {
      start += Math.ceil(end / 40); // Ticks up smoothly by chunks
      if (start >= end) {
        clearInterval(timer);
        setDisplayCredits(end); // Ensure we land exactly on the target number
      } else {
        setDisplayCredits(start);
      }
    }, incrementTime);

    return () => clearInterval(timer);
  }, [credits]);

  return (
    <div className="credits-card-container">
      <span className="credits-header-title">CREDITS EARNED</span>
      
      <div className="credits-reward-zone">
        {/* Shiny CSS Gold Coin Built In */}
        <div className="rewards-gold-coin animate-pop-in">
          <div className="rewards-inner-ridge">
            <span className="rewards-coin-star">★</span>
          </div>
          <div className="rewards-coin-glint"></div>
        </div>

        {/* Rolling Counter Text */}
        <div className="credits-counter-display">
          <span className="credits-number-roll">+{displayCredits.toLocaleString()}</span>
        </div>
      </div>
    </div>
  );
}